import _JSXStyle from "styled-jsx/style";
import { mutuallyExclusive } from '@dhis2/prop-types';
import { colors, spacers } from '@dhis2/ui-constants';
import { IconErrorFilled24, IconWarningFilled24, IconInfoFilled24, IconCheckmarkCircle24 } from '@dhis2/ui-icons';
import PropTypes from 'prop-types';
import React from 'react';
export const NoticeBoxIcon = _ref => {
  let {
    valid,
    warning,
    error,
    dataTest
  } = _ref;
  // Info is the default icon
  let color = colors.blue900;
  let Icon = IconInfoFilled24;

  if (valid) {
    color = colors.green700;
    Icon = IconCheckmarkCircle24;
  }

  if (warning) {
    color = colors.yellow700;
    Icon = IconWarningFilled24;
  }

  if (error) {
    color = colors.red700;
    Icon = IconErrorFilled24;
  }

  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1909501516", [spacers.dp12, spacers.dp24]]])
  }, /*#__PURE__*/React.createElement(Icon, {
    color: color,
    className: _JSXStyle.dynamic([["1909501516", [spacers.dp12, spacers.dp24]]])
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1909501516",
    dynamic: [spacers.dp12, spacers.dp24]
  }, [".__jsx-style-dynamic-selector{margin-inline-end:".concat(spacers.dp12, ";height:").concat(spacers.dp24, ";}")]));
};
NoticeBoxIcon.propTypes = {
  dataTest: PropTypes.string.isRequired,
  error: mutuallyExclusive(['error', 'valid', 'warning'], PropTypes.bool),
  valid: mutuallyExclusive(['error', 'valid', 'warning'], PropTypes.bool),
  warning: mutuallyExclusive(['error', 'valid', 'warning'], PropTypes.bool)
};